export const BESCHAEFTIGUNG_ARTEN: string[] = [
  'Absolvent*in freiwilliges soziales Jahr',
  'Angestellt (Teilzeit)',
  'Angestellt (Vollzeit)',
  'Angestellte*r im öffentlichen Dienst',
  'arbeitssuchend',
  'Auslandaufenthalt',
  'Beamte*r auf Lebenszeit',
  'Beamte*r auf Probe',
  'Beamte*r auf Widerruf',
  'Beamte*r auf Zeit',
  'Berufssoldat*in',
  'Ehrenamtlich tätig',
  'Erasmus-Programm',
  'Freiberuflich',
  'Freiwillig Wehrdienstleistende*r',
  'Gap Year',
  'Geringfügig Beschäftigte*r',
  'Hausfrau/Hausmann',
  'Leitende*r Angestellte*r',
  'Praktikant*in',
  'Selbstständige*r',
  'Sonstiges',
  'Zeitsoldat*in'
];
